import { useLocation } from 'react-router-dom';

export const useDemoMode = () => {
  const location = useLocation();
  
  const isDemoMode = location.pathname.includes('/demo');
  
  return {
    isDemoMode,
    demoPath: '/map/demo',
    productionPath: '/map'
  };
};